import { IAction } from '../root/i-action';
import { IState } from '../root/state.interface';
import {
  IMermaidSchemaConfig,
  IRulesConfig,
  IRulesFields,
  ITenant,
  ITenantProperty,
  ITenantRulesConfig,
  ITenantRulesConfigSchema,
  IWrappedSchema,
} from './i-tenant';

export const zonesSaveRequest = (state: IState): IState => ({
  ...state,
  zonesSaveState: {
    loading: true,
    loaded: false,
    data: null,
  },
});

export const zonesSaveSuccess = (state: IState): IState => ({
  ...state,
  zonesSaveState: {
    loading: false,
    loaded: true,
    data: null,
  },
});

export const zonesSaveFail = (state: IState): IState => ({
  ...state,
  zonesSaveState: {
    loading: false,
    loaded: false,
    data: null,
    // error: action.payload,
  },
});

// eslint-disable-next-line
export const tenantRulesConfigSaveRequest = (state: IState): any => ({
  ...state,
  loading: true,
  error: undefined,
  loaded: false,
});

// eslint-disable-next-line
export const tenantRulesConfigSaveSuccess = (state: IState): any => ({
  ...state,
  loading: false,
  error: undefined,
  loaded: true,
});

// eslint-disable-next-line
export const tenantRulesConfigSaveFail = (state: IState, action: IAction): any => ({
  ...state,
  loading: false,
  error: action.payload,
  loaded: false,
});

export const getTenantsListStart = (state: IState): IState => ({
  ...state,
  tenants: {
    data: [],
    loading: true,
    error: undefined,
    loaded: true,
  },
});

export const getTenantsListFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  tenants: {
    data: [],
    loading: false,
    error: action.payload,
  },
});

export const getTenantsListSuccess = (state: IState, action: IAction<ITenant[]>): IState => ({
  ...state,
  tenants: {
    data: action.payload,
    loading: false,
    error: undefined,
  },
});

export const getTenantPropertiesListStart = (state: IState): IState => ({
  ...state,
  tenantProperties: {
    data: {},
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const getTenantPropertiesListSuccess = (
  state: IState, action: IAction<ITenantProperty>,
): IState => ({
  ...state,
  tenantProperties: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

// eslint-disable-next-line max-len
export const getTenantPropertiesListFail = (state: IState): IState => ({
  ...state,
  tenantProperties: {
    data: {},
    loading: false,
    loaded: false,
    error: undefined,
  },
});

export const getWrappedSchemaRequest = (state: IState): IState => ({
  ...state,
  wrappedSchema: {
    data: {},
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const getWrappedSchemaSuccess = (
  state: IState, action: IAction<IWrappedSchema>,
): IState => ({
  ...state,
  wrappedSchema: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

// eslint-disable-next-line max-len
export const getWrappedSchemaFail = (state: IState): IState => ({
  ...state,
  wrappedSchema: {
    data: {},
    loading: false,
    loaded: false,
    error: undefined,
  },
});

export const tenantRulesConfigRequest = (state: IState): IState => ({
  ...state,
  tenantRules: {
    data: {},
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const tenantRulesConfigSuccess = (
  state: IState, action: IAction<ITenantRulesConfig>,
): IState => ({
  ...state,
  tenantRules: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const tenantRulesConfigFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  tenantRules: {
    data: {},
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const tenantRulesConfigSchemaRequest = (state: IState): IState => ({
  ...state,
  tenantRulesSchema: {
    data: {},
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const tenantRulesConfigSchemaSuccess = (
  state: IState, action: IAction<ITenantRulesConfigSchema>,
): IState => ({
  ...state,
  tenantRulesSchema: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const tenantRulesConfigSchemaFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  tenantRulesSchema: {
    data: {},
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const rulesConfigSchemaRequest = (state: IState): IState => ({
  ...state,
  rulesFields: {
    data: {},
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const rulesConfigSchemaSuccess = (
  state: IState, action: IAction<IRulesFields>,
): IState => ({
  ...state,
  rulesFields: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});
export const rulesConfigSchemaFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  rulesFields: {
    data: {},
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const rulesPseudoCodeRequest = (state: IState): IState => ({
  ...state,
  rulesPseudocode: {
    data: '',
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const rulesPseudoCodeSuccess = (
  state: IState, action: IAction<string>,
): IState => ({
  ...state,
  rulesPseudocode: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const rulesPseudoCodeFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  rulesPseudocode: {
    data: '',
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const rulesConfigSuccess = (
  state: IState, action: IAction<IRulesConfig>,
): IState => ({
  ...state,
  rulesConfig: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const rulesConfigSaveRequest = (state: IState): unknown => ({
  ...state,
  rulesConfig: {
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const rulesConfigSaveSuccess = (state: IState): unknown => ({
  ...state,
  rulesConfig: {
    loading: false,
    error: undefined,
    loaded: true,
  },
});

export const rulesConfigSaveFail = (state: IState, action: IAction): unknown => ({
  ...state,
  loading: false,
  error: action.payload,
  loaded: false,
});

export const tenantMermaidDiagramRequest = (state: IState): IState => ({
  ...state,
  mermaidDiagram: {
    data: {},
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const tenantMermaidDiagramSuccess = (
  state: IState, action: IAction<IMermaidSchemaConfig>,
): IState => ({
  ...state,
  mermaidDiagram: {
    data: action.payload,
    loading: false,
    error: undefined,
    loaded: true,
  },
});
export const tenantMermaidDiagramFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  mermaidDiagram: {
    data: {},
    loading: false,
    error: action.payload,
    loaded: false,
  },
});
